Namespace.create('cv.Views.Team').SetupView = Marionette.LayoutView.extend({
  template: cv.Templates['team/setup/view'],

  className : 'view-setup',

  regions : {
    region_content : '#region-content'
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    'show' : function() {
      // Update the h2 text
      this.$('h2').text('Create a New Team');

      // Update the styles
      this.updateStyles();
    },
    'render' : function() {
      // Update the h2 text
      this.$('h2').text('Create a New Team');

      // Update the styles
      this.updateStyles();
    }
  },

  events : {
    'click .back' : function(e){
      e.preventDefault();

      vent.trigger('setup:prev_screen');
    },
    'click .view-setup__nav a' : 'clickNav'
  },

  validation: {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // The array holding all screens for this setup
    this.screens = [{
      'screen' : 'page',
      'label' : 'Set Up Team Page'
    },{
      'screen' : 'appeal',
      'label' : 'Write Your Appeal'
    },{
      'screen' : 'share',
      'label' : 'Share With Friends'
    }];


    // Model
    this.model = new Backbone.Model({
      'screen' : ''
    });

    this.listenTo(this.model, 'change:screen', function(){
      this.renderSidebar(this.model.get('screen'));
      this.renderScreen(this.model.get('screen'));

      cv.router.navigate('team_setup/' + this.model.get('screen'), { replace : true });
    }, this);

    this.listenTo(vent, 'setup:prev_screen', this.previousScreen, this);
    this.listenTo(vent, 'setup:next_screen', this.nextScreen, this);
    this.listenTo(vent, 'setup:process_stripe', this.processStripe, this);
  },


  previousScreen: function(){
    console.log('Advancing to previous screen...');

    var screen_index = this.screens.map(function(e) { return e.screen; }).indexOf(this.model.get('screen'));
    this.model.set('screen', this.screens[screen_index - 1].screen);
  },

  nextScreen: function(){
    console.log('Advancing to next screen...');

    var screen_index = this.screens.map(function(e) { return e.screen; }).indexOf(this.model.get('screen'));
    this.model.set('screen', this.screens[screen_index + 1].screen);
  },

  clickNav: function(e){
    e.preventDefault();

    var screen = $(e.currentTarget).parent().data('link');
    this.model.set('screen', screen);
  },

  renderSidebar: function(screen){
    var blah = false;

    // Reset any old styles
    this.$('.view-setup__nav li').removeAttr('style');
    this.$('.view-setup__nav li .step').removeAttr('style');

    // Build the navigation styles
    _.each(this.screens, function(item, index, list){
      if(blah == false){
        if(item.screen == screen){
          this.$('li[data-link="' + item.screen + '"]').removeClass('active complete').addClass('active');
          this.$('li[data-link="' + item.screen + '"] .step').removeAttr('data-color data-background').attr('data-color', 'main_color');
          blah = true;
        }else{
          this.$('li[data-link="' + item.screen + '"]').removeClass('active complete').addClass('complete');
          this.$('li[data-link="' + item.screen + '"] .step').removeAttr('data-color data-background').attr('data-background', 'accent_color');
        }
      }else{
        this.$('li[data-link="' + item.screen + '"]').removeClass('active complete');
        this.$('li[data-link="' + item.screen + '"] .step').removeAttr('data-color data-background');
      }

    }, this);

    this.$('li[data-link="' + screen + '"]').addClass('active');
    this.$('li[data-link="' + screen + '"] .step').removeAttr('data-color data-background').attr('data-color', 'main_color');
  },

  renderScreen: function(screen){
    if(_.isUndefined(cv.project.get('team.id'))){
      var model = new cv.Team();
    }else{
      var model = new cv.Team({
        id : cv.project.get('team.id'),
        url : cv.project.get('team.url') // This is for the share page
      });
    }

    // Show the view
    switch(screen){
      case 'appeal':
        var view = new cv.Views.Team.Setup.AppealView({
          model : model
        });
        break;
      case 'share':
        var view = new cv.Views.Team.Setup.ShareView({
          model : model
        });
        break;
      case 'page':
      default:
        var view = new cv.Views.Team.Setup.PageView({
          model : model
        });
    }
    this.showChildView('region_content', view);

    // Fade in and out
    this.$('#region-content > div').hide().fadeIn("fast");

    // Reset the scroll
    $('html, body').animate({
      scrollTop: 0
    }, 100);
  },

  updateStyles: function(){
    // Change the color based on the background colors
    _.each(this.$('[data-color]'), function(el){
      var color_attr = $(el).data('color');
      this.$(el).css('color', cv.campaign.get('branding.' + color_attr) + ' !important;');
    }, this);

    _.each(this.$('[data-background]'), function(el){
      var background_attr = $(el).data('background');
      var text_color = cv.getTextColor(cv.campaign.get('branding.' + background_attr));
      this.$(el).css('background-color', cv.campaign.get('branding.' + background_attr) + ' !important;');
      this.$(el).css('color', text_color + ' !important;');
    }, this);
  },

  onAttach: function(){
    // Build the navigation
    _.each(this.screens, function(item, index, list){
      this.$('.view-setup__nav ul').append(
        '<li data-link="' + item.screen + '">' +
          '<a href="#">' + item.label + '</a>' +
          '<div class="step">' + (index + 1) +  '</div>' +
        '</li>'
      )
    }, this);

    if(_.isNull(this.options.tab)) {
      this.options.tab = 'page';
    }
    this.model.set('screen', this.options.tab);
  }
});